const config = {
    apiUrl: process.env.NODE_ENV === 'production' ? 'https://api.keymash.io' : 'http://localhost:8080'
}

export default config;
